"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtraFiltersEnum;
(function (ExtraFiltersEnum) {
    ExtraFiltersEnum["allWheelDrive"] = "all-wheel-drive";
    ExtraFiltersEnum["automat"] = "automat";
    ExtraFiltersEnum["extraLabel"] = "extra-label";
})(ExtraFiltersEnum || (ExtraFiltersEnum = {}));
exports.default = ExtraFiltersEnum;
